import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const USER_INFO_CACHE_KEY = 'learning_mng_user_info'

function readUserInfoCache() {
  try {
    const raw = sessionStorage.getItem(USER_INFO_CACHE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function writeUserInfoCache(token, data) {
  if (!token || !data) return
  try {
    sessionStorage.setItem(USER_INFO_CACHE_KEY, JSON.stringify({ token, data }))
  } catch (e) {
    // ignore quota / private mode
  }
}

function clearUserInfoCache() {
  sessionStorage.removeItem(USER_INFO_CACHE_KEY)
}

function applyUserInfo(commit, data) {
  if (!data.roles || data.roles.length === 0) {
    return false
  }
  commit('SET_ROLES', data.roles)
  commit('SET_NAME', data.username)
  commit('SET_AVATAR', data.icon)
  return true
}

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          clearUserInfoCache()
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息（sessionStorage 按 token 缓存，登录/登出会清除）
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const cached = readUserInfoCache()
        if (cached && cached.token === state.token && cached.data) {
          if (applyUserInfo(commit, cached.data)) {
            resolve({ data: cached.data })
            return
          }
          clearUserInfoCache()
        }

        getInfo().then(response => {
          const data = response.data
          if (!applyUserInfo(commit, data)) {
            reject('getInfo: roles must be a non-null array !')
            return
          }
          writeUserInfoCache(state.token, data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          clearUserInfoCache()
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        clearUserInfoCache()
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js